module.exports = __webpack_public_path__ + "static/media/hakimuddin_slatewala.28500e54.png";